import { render, staticRenderFns } from "./PagesCategoryToplistWidget.vue?vue&type=template&id=332bf98d&"
import script from "./PagesCategoryToplistWidget.vue?vue&type=script&lang=js&"
export * from "./PagesCategoryToplistWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports